import React, { useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'
import Sort from '../../assets/images/llantas/table/sort.svg'
import SortAsc from '../../assets/images/llantas/table/sort-asc.svg'
import SortDesc from '../../assets/images/llantas/table/sort-desc.svg'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import UpIcon from '@material-ui/icons/KeyboardArrowUp'
import Loading from '../ui/Loading.js'
import {
	Table,
	TableContainer,
	TableHead,
	TableRow,
	TableBody,
	TablePagination,
	Modal,
} from '@material-ui/core'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import { makeStyles } from '@material-ui/core/styles'
import { StyledTableCell, rowsPerPage } from '../../commons/utils/TableStyles'
import * as Utils from '../../commons/utils/Utils'
import { FormattedMessage, useIntl } from 'react-intl'
import backendStrings from '../../lang/backendStrings.js'
import SafeFeedbackRankingGridRow from './SafeFeedbackRankingGridRow.jsx'
import SafeFeedbackRankingGridFiltros from './SafeFeedbackRankingGridFiltros.jsx'
import SafeFeedbackRankingDetalleModal from './SafeFeedbackRankingDetalleModal.jsx'
import Security from '../../commons/security/Security'

const useStyles = makeStyles((theme) => ({
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: '15px',
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: '0px solid #000',
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		borderRadius: '15px',
		width: '900px',
		maxHeight: '80vh',
		overflowY: 'auto',
	},
}))

const PAGINATION_INIT = {
	page: 0,
	count: 0,
	perPage: 10,
}

const FILTER_QUERY_INIT = {
	fechaDesde: '',
	fechaHasta: '',
	conductorId: '',
	tipoFormularioId: '',
}

const SORT_QUERY_INIT = {
	puntuacion: 'desc',
	totalEventos: '',
}

const STORAGE_KEY = 'SafeFeedbackRankingGridFilters'

const getStorage = () => {
	let storage = JSON.parse(window.localStorage.getItem(STORAGE_KEY))
	return storage && storage.activo ? true : false
}

const SafeFeedbackRankingGrid = (props) => {
	const intl = useIntl()
	const classes = useStyles()

	const [ranking, setRanking] = useState([])
	const [loading, setLoading] = useState(false)
	const [pagination, setPagination] = useState({ ...PAGINATION_INIT })
	const [paginationCount, setPaginationCount] = useState(0)
	const [filterQuery, setFilterQuery] = useState(null)
	const [sortQuery, setSortQuery] = useState({ ...SORT_QUERY_INIT })
	const [dropdownActive, setDropdownActive] = useState(false)
	const [searchActive, setSearchActive] = useState(false)
	const [conductorDetalle, setConductorDetalle] = useState(null)
	const [showDetalleModal, setShowDetalleModal] = useState(false)
	const [resetFilterInputs, setResetFilterInputs] = useState(false)
	const [filterResetInputs, setFilterResetInputs] = useState(false)
	const [redirectTo, setRedirectTo] = useState(null)
	const [summaryAlerts, setSummaryAlerts] = useState(null)
	const [persisteFiltros, setPersisteFiltros] = useState(getStorage())

	useEffect(() => {
		setLoading(true)
		if (Security.hasPermission('SAFEFEEDBACK_RANKING_LISTAR')) {
			filterQuery && init()
		} else {
			setRedirectTo('/error')
		}
		return () => {}
	}, [pagination, filterQuery, sortQuery])

	const init = () => {
		Utils.getData('/safe-feedback-ranking' + getQuery())
			.then((data) => {
				setRanking(data.ranking)
				setPaginationCount(data.pagination.count)
				setSummaryAlerts(data.totales)
				setLoading(false)
			})
			.catch(() => {
				setLoading(false)
			})
	}

	const getQuery = () => {
		let query = '?page=' + pagination.page
		query += '&perPage=' + pagination.perPage
		query += '&fechaDesde=' + filterQuery.fechaDesde
		query += '&fechaHasta=' + filterQuery.fechaHasta
		query += '&conductorId=' + filterQuery.conductorId
		query += '&tipoFormularioId=' + filterQuery.tipoFormularioId
		query += '&puntuacionSort=' + sortQuery.puntuacion
		query += '&totalEventosSort=' + sortQuery.totalEventos
		return query
	}

	const handlePageChange = (event, newPage) => {
		setPagination({ ...pagination, page: newPage })
	}

	const handleRowsPerPageChange = (event) => {
		setPagination({ ...pagination, perPage: parseInt(event.target.value, 10), page: 0 })
	}

	const handleSort = (key) => {
		let query = { ...SORT_QUERY_INIT }
		let orden = (sortQuery[key] === '' || sortQuery[key] === 'desc') ? 'asc' : 'desc'
		query[key] = orden
		setSortQuery(query)
	}

	const handleFilterReset = () => {
		setPagination(PAGINATION_INIT)
		setFilterQuery(FILTER_QUERY_INIT)
		setSortQuery(SORT_QUERY_INIT)
		setDropdownActive(false)
		setSearchActive(false)
		setResetFilterInputs(true)
		setFilterResetInputs(true)
	}

	const handleFilterChange = () => {
		setPagination((prev) => ({ ...prev, page: 0 }))
	}

	const reloadData = () => {
		setLoading(true)
		init()
	}

	return (
		<>
			{redirectTo && <Redirect push to={redirectTo} />}
			{loading && <Loading />}
			{summaryAlerts && (
				<section className="combustiblesWidget">
					<div className="row justify-content-around">
						{summaryAlerts.map((alert, index) => (
							<div key={index} className="col-xl-2 col-lg-4 col-12" style={{ paddingRight: '0.5rem', paddingLeft: '0.5rem' }}>
								<div className="card pull-up">
									<div className="card-content">
										<div style={{ padding: '15px' }} className="card-body">
											<div className="media d-flex">
												<div className="align-self-center">
													<i className={alert.iconClass} style={{ color: alert.iconColor }}></i>
												</div>
												<div className="media-body text-right">
													<span><FormattedMessage {...(backendStrings[alert.description] ? backendStrings[alert.description] : backendStrings['errors.default'])} /></span>
													<h3><b>{!alert.value ? 0 : alert.value}</b></h3>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
				</section>
			)}
			<div className="card">
				<div className="card-content">
					<div className="card-body card-dashboard">
						<div className="container-fluid mb-1">
							<div className="row dt-icons" style={{ width: '100%' }}>
								<div className="col">
									<div
										className="btn btn-grey-blue box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
										style={{ height: 52, marginLeft: '-13px', marginTop: '6px' }}
										onClick={() => setDropdownActive(!dropdownActive)}
									>
										{dropdownActive ? <UpIcon /> : <ExpandMoreIcon />}
									</div>
								</div>
								<div className="col">
									{searchActive && (
										<div className="btn-dt-main round-icon">
											<div
												className="text-center"
												style={{
													height: '25px',
													borderRadius: '3px',
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													paddingLeft: '8px',
													backgroundColor: '#5AAC43',
													color: 'white',
												}}
											>
												<div className="text-center" style={{ width: '100%', fontSize: '12px', fontWeight: '500' }}>
													{ranking.length} de {paginationCount} resultados de busqueda
												</div>
												<div className="resultados-busqueda-notif">
													<i className="las la-times la-xs cursor-pointer" onClick={() => handleFilterReset()} />
												</div>
											</div>
										</div>
									)}
								</div>
								<div className="col" />
							</div>
						</div>

						<div className="alert" style={{ fontSize: '13px', marginBottom: '12px', backgroundColor: '#0abfbc8f', borderColor: '#4dc4bc', color: '#053858' }}>
							<i className="fa fa-info-circle mr-1" />
							<FormattedMessage
								id="SafeFeedbackRankingGrid.leyenda"
								defaultMessage="Solo los reportes confirmados impactan en la puntuación. Los desestimados y pendientes se muestran con fines informativos."
							/>
						</div>

						<SafeFeedbackRankingGridFiltros
							resetFilterInputs={resetFilterInputs}
							setResetFilterInputs={setResetFilterInputs}
							filterQuery={filterQuery}
							setFilterQuery={setFilterQuery}
							dropdownActive={dropdownActive}
							setDropdownActive={setDropdownActive}
							searchActive={searchActive}
							setSearchActive={setSearchActive}
							handleFilterChange={handleFilterChange}
							filterResetInputs={filterResetInputs}
							setFilterResetInputs={setFilterResetInputs}
							persisteFiltros={persisteFiltros}
							setPersisteFiltros={setPersisteFiltros}
						/>

						<TableContainer>
							<Table>
								<TableHead>
									<TableRow>
										<StyledTableCell align="left">
											<FormattedMessage id="SafeFeedbackRankingGrid.column_posicion" defaultMessage="#" />
										</StyledTableCell>
										<StyledTableCell align="left">
											<FormattedMessage id="SafeFeedbackRankingGrid.column_conductor" defaultMessage="Conductor" />
										</StyledTableCell>
										<StyledTableCell
											align="left"
											style={{ cursor: 'pointer' }}
											onClick={() => handleSort('puntuacion')}
										>
											<FormattedMessage id="SafeFeedbackRankingGrid.column_puntuacion" defaultMessage="Puntuación" />
											<img
												className="ml-1"
												src={sortQuery.puntuacion === '' ? Sort : sortQuery.puntuacion === 'asc' ? SortAsc : SortDesc}
												alt="/"
												style={{ height: '12px', width: '22px' }}
											/>
										</StyledTableCell>
										<StyledTableCell
											align="left"
											style={{ cursor: 'pointer' }}
											onClick={() => handleSort('totalEventos')}
										>
											<FormattedMessage id="SafeFeedbackRankingGrid.column_total_eventos" defaultMessage="Total eventos" />
											<img
												className="ml-1"
												src={sortQuery.totalEventos === '' ? Sort : sortQuery.totalEventos === 'asc' ? SortAsc : SortDesc}
												alt="/"
												style={{ height: '12px', width: '22px' }}
											/>
										</StyledTableCell>
										<StyledTableCell align="left">
											<FormattedMessage id="SafeFeedbackRankingGrid.column_confirmados" defaultMessage="Confirmados" />
										</StyledTableCell>
										<StyledTableCell align="left">
											<FormattedMessage id="SafeFeedbackRankingGrid.column_desestimados" defaultMessage="Desestimados" />
										</StyledTableCell>
										<StyledTableCell align="left">
											<FormattedMessage id="SafeFeedbackRankingGrid.column_acciones" defaultMessage="Acciones" />
										</StyledTableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{loading && (
										<TableRow>
											<StyledTableCell colSpan={7} align="center">
												<FormattedMessage id="Cargando" defaultMessage="Cargando" />
											</StyledTableCell>
										</TableRow>
									)}
									{!loading && ranking && ranking.map((item) => (
										<SafeFeedbackRankingGridRow
											key={'safeFeedbackRankingGridRow_' + item.conductor_id}
											item={item}
											onVisualizar={(item) => { setConductorDetalle(item); setShowDetalleModal(true) }}
										/>
									))}
								</TableBody>
							</Table>
						</TableContainer>
						<TablePagination
							rowsPerPageOptions={rowsPerPage}
							component="div"
							count={paginationCount}
							rowsPerPage={pagination.perPage}
							page={pagination.page}
							onPageChange={handlePageChange}
							onRowsPerPageChange={handleRowsPerPageChange}
							labelRowsPerPage="Mostrar"
							labelDisplayedRows={({ from, to, count }) => 'Mostrando ' + from + ' a ' + to + ' de ' + count}
						/>
					</div>
				</div>
			</div>

			<Modal
				open={showDetalleModal}
				onClose={() => setShowDetalleModal(false)}
				className={classes.modal}
				BackdropComponent={Backdrop}
				BackdropProps={{ timeout: 500 }}
			>
				<Fade in={showDetalleModal}>
					<div className={classes.paper}>
						{conductorDetalle && (
							<SafeFeedbackRankingDetalleModal
								conductor={conductorDetalle}
								onClose={() => setShowDetalleModal(false)}
							/>
						)}
					</div>
				</Fade>
			</Modal>
		</>
	)
}

export default SafeFeedbackRankingGrid
